import { combineEpics } from "redux-observable";
import contactAssociationsEpic from "./contact-associations-fetch";
import contactProfileEpic from "./contact-profile-fetch";

export default combineEpics(contactAssociationsEpic, contactProfileEpic);
